import { useMutation, useQuery } from "react-query";
import { HttpBaseRequest } from "../../../../core/HttpRequest";
import {
  addSupplier,
  getSupplier,
  getSuppliers,
  updateSupplier,
} from "./service";
import { useErrorHandler } from "../../../../hooks/useErrorHandler";
import { AxiosError } from "axios";
import { Form_Supplier, Form_Update_Supplier } from "../../form/Form";
import useSuccessHandler from "../../../../hooks/useSuccessHandler";

export const useGetSuppliers = ({
  keyword,
  page,
  perPage,
}: HttpBaseRequest) => {
  const { redirectOnTokenExpired } = useErrorHandler();

  return useQuery({
    queryKey: `suppliers-${keyword}-${page}-${perPage}`,
    queryFn: () => getSuppliers({ keyword, page, perPage }),
    onError: (e: AxiosError) => redirectOnTokenExpired(e),
  });
};

export const useGetSupplier = ({ supplier_id }: { supplier_id?: string }) => {
  const { redirectOnTokenExpired } = useErrorHandler();

  return useQuery({
    enabled: supplier_id !== undefined,
    queryKey: `suppliers-${supplier_id}`,
    queryFn: () => getSupplier({ supplier_id }),
    onError: (e: AxiosError) => redirectOnTokenExpired(e),
  });
};

export const useAddSupplier = () => {
  const { showToastOnError } = useErrorHandler();
  const { showToast, redirect } = useSuccessHandler();

  return useMutation({
    mutationKey: `addSupplier`,
    mutationFn: ({
      supplier_address,
      supplier_name,
      supplier_phone_number,
    }: Form_Supplier) =>
      addSupplier({ supplier_address, supplier_name, supplier_phone_number }),
    onSuccess: (e) => {
      showToast("Berhasil menambahkan supplier baru");
      redirect("/supplier");
    },
    onError: (e: AxiosError) => showToastOnError(e),
  });
};

export const useUpdateSupplier = () => {
  const { showToastOnError } = useErrorHandler();
  const { showToast, redirect } = useSuccessHandler();

  return useMutation({
    mutationKey: `updateSupplier`,
    mutationFn: ({
      supplier_id,
      supplier_address,
      supplier_name,
      supplier_phone_number,
    }: Form_Update_Supplier) =>
      updateSupplier({
        supplier_id,
        supplier_address,
        supplier_name,
        supplier_phone_number,
      }),
    onSuccess: (e) => {
      showToast("Berhasil update supplier");
      redirect("/supplier");
    },
    onError: (e: AxiosError) => showToastOnError(e),
  });
};
